"use strict";

var EnvelopeLiner = require('./EnvelopeLiner');

var EuroFlapEnvelopeLiner = require('./EuroFlapEnvelopeLiner');

var Invitation = require('./Invitation');

var InvitationEnvelope = require('./InvitationEnvelope');

var LargeEnclosure = require('./LargeEnclosure');

var LetterpressInvitation = require('./LetterpressInvitation');

var LetterpressLargeEnclosure = require('./LetterpressLargeEnclosure');

var LetterpressResponseCard = require('./LetterpressResponseCard');

var LetterpressSmallEnclosure = require('./LetterpressSmallEnclosure');

var LetterpressSaveTheDate = require('./LetterpressSaveTheDate');

var ResponseCard = require('./ResponseCard');

var ResponseCardEnvelope = require('./ResponseCardEnvelope');

var SmallEnclosure = require('./SmallEnclosure');

var ThickWrapper = require('./ThickWrapper');

var MediumWrapper = require('./MediumWrapper');

var VellumJacket = require('./VellumJacket');

var WaxSeal = require('./WaxSeal');

var Wrapper = require('./Wrapper');

var RibbonSpool = require('./RibbonSpool');

var SaveTheDate = require('./SaveTheDate');

var SaveTheDateEnvelope = require('./SaveTheDateEnvelope');

var SquareProgram = require('./SquareProgram');

var ThankYouCard = require('./ThankYouCard');

var ThankYouCardEnvelope = require('./ThankYouCardEnvelope');

var FlatBookletProgram = require('./FlatBookletProgram');

var DeluxeBookletProgramCover = require('./DeluxeBookletProgramCover');

var DeluxeBookletProgramInterior = require('./DeluxeBookletProgramInterior');

var BasicBookletProgram = require('./BasicBookletProgram');

var CustomSign = require('./CustomSign');

var FavorTag = require('./FavorTag');

var PlaceCard = require('./PlaceCard');

var ReservedSign = require('./ReservedSign');

var SeatingChart = require('./SeatingChart');

var TableNumber = require('./TableNumber');

var WeddingMenu = require('./WeddingMenu');

var LetterpressWeddingMenu = require('./LetterpressWeddingMenu');

var WeddingSign = require('./WeddingSign');

var WelcomeSign = require('./WelcomeSign');

var FreeClassicInvitationSample = require('./FreeClassicInvitationSample');

var PaidClassicInvitationSample = require('./PaidClassicInvitationSample');

var FreeLetterpressInvitationSample = require('./FreeLetterpressInvitationSample');

var PaidLetterpressInvitationSample = require('./PaidLetterpressInvitationSample');

var RibbonSample = require('./RibbonSample');

var AccessoriesThankYouCard = require('./AccessoriesThankYouCard');

var ComponentsCard = require('./ComponentsCard');

var DoubleThickExampleCard = require('./DoubleThickExampleCard');

var EnvelopeLinerInsert = require('./EnvelopeLinerInsert');

var Information2018Card = require('./Information2018Card');

var InvitationThankYouCard = require('./InvitationThankYouCard');

var LetterpressSampleCard = require('./LetterpressSampleCard');

var OrderTimelineCard = require('./OrderTimelineCard');

var PackedByCard = require('./PackedByCard');

var PhotographyInsert = require('./PhotographyInsert');

var RibbonInstruction = require('./RibbonInstruction');

var RibbonSampleInstruction = require('./RibbonSampleInstruction');

var SaveTheDateThankYouCard = require('./SaveTheDateThankYouCard');

var StandardInstruction = require('./StandardInstruction');

var WhyShineCard = require('./WhyShineCard');

var CustomColorChart = require('./CustomColorChart');

var ColorChart = require('./ColorChart');

var ColorChartLiner = require('./ColorChartLiner');

var SampleInvitation = require('./SampleInvitation');

var SampleInvitationEnvelope = require('./SampleInvitationEnvelope');

var SampleEnvelopeLiner = require('./SampleEnvelopeLiner');

var SampleResponseCard = require('./SampleResponseCard');

var SampleResponseCardEnvelope = require('./SampleResponseCardEnvelope');

var SampleSmallEnclosure = require('./SampleSmallEnclosure');

var SampleLargeEnclosure = require('./SampleLargeEnclosure');

var SampleWrapper = require('./SampleWrapper');

var SampleThickWrapper = require('./SampleThickWrapper');

var SampleMediumWrapper = require('./SampleMediumWrapper');

var RibbonSampleCard = require('./RibbonSampleCard');

var LinerSample = require('./LinerSample');

var WeddingPlannerBox = require('./WeddingPlannerBox');

var Announcement = require('./Announcement');

module.exports = {
  MediumWrapper: MediumWrapper,
  SampleMediumWrapper: SampleMediumWrapper,
  Announcement: Announcement,
  WeddingPlannerBox: WeddingPlannerBox,
  LinerSample: LinerSample,
  RibbonSampleCard: RibbonSampleCard,
  SampleThickWrapper: SampleThickWrapper,
  SampleWrapper: SampleWrapper,
  SampleLargeEnclosure: SampleLargeEnclosure,
  SampleSmallEnclosure: SampleSmallEnclosure,
  SampleResponseCardEnvelope: SampleResponseCardEnvelope,
  SampleResponseCard: SampleResponseCard,
  SampleEnvelopeLiner: SampleEnvelopeLiner,
  SampleInvitationEnvelope: SampleInvitationEnvelope,
  SampleInvitation: SampleInvitation,
  ColorChartLiner: ColorChartLiner,
  ColorChart: ColorChart,
  CustomColorChart: CustomColorChart,
  WhyShineCard: WhyShineCard,
  StandardInstruction: StandardInstruction,
  SaveTheDateThankYouCard: SaveTheDateThankYouCard,
  RibbonSampleInstruction: RibbonSampleInstruction,
  RibbonInstruction: RibbonInstruction,
  PhotographyInsert: PhotographyInsert,
  PackedByCard: PackedByCard,
  OrderTimelineCard: OrderTimelineCard,
  LetterpressSampleCard: LetterpressSampleCard,
  InvitationThankYouCard: InvitationThankYouCard,
  Information2018Card: Information2018Card,
  EnvelopeLinerInsert: EnvelopeLinerInsert,
  DoubleThickExampleCard: DoubleThickExampleCard,
  ComponentsCard: ComponentsCard,
  AccessoriesThankYouCard: AccessoriesThankYouCard,
  CustomSign: CustomSign,
  FavorTag: FavorTag,
  PlaceCard: PlaceCard,
  ReservedSign: ReservedSign,
  SeatingChart: SeatingChart,
  TableNumber: TableNumber,
  WeddingMenu: WeddingMenu,
  LetterpressWeddingMenu: LetterpressWeddingMenu,
  WeddingSign: WeddingSign,
  WelcomeSign: WelcomeSign,
  EnvelopeLiner: EnvelopeLiner,
  EuroFlapEnvelopeLiner: EuroFlapEnvelopeLiner,
  Invitation: Invitation,
  InvitationEnvelope: InvitationEnvelope,
  LargeEnclosure: LargeEnclosure,
  LetterpressInvitation: LetterpressInvitation,
  LetterpressLargeEnclosure: LetterpressLargeEnclosure,
  LetterpressResponseCard: LetterpressResponseCard,
  LetterpressSmallEnclosure: LetterpressSmallEnclosure,
  LetterpressSaveTheDate: LetterpressSaveTheDate,
  ResponseCard: ResponseCard,
  ResponseCardEnvelope: ResponseCardEnvelope,
  SmallEnclosure: SmallEnclosure,
  ThickWrapper: ThickWrapper,
  VellumJacket: VellumJacket,
  WaxSeal: WaxSeal,
  Wrapper: Wrapper,
  SaveTheDate: SaveTheDate,
  SaveTheDateEnvelope: SaveTheDateEnvelope,
  SquareProgram: SquareProgram,
  ThankYouCard: ThankYouCard,
  ThankYouCardEnvelope: ThankYouCardEnvelope,
  FlatBookletProgram: FlatBookletProgram,
  DeluxeBookletProgramCover: DeluxeBookletProgramCover,
  DeluxeBookletProgramInterior: DeluxeBookletProgramInterior,
  BasicBookletProgram: BasicBookletProgram,
  RibbonSpool: RibbonSpool,
  FreeClassicInvitationSample: FreeClassicInvitationSample,
  PaidClassicInvitationSample: PaidClassicInvitationSample,
  FreeLetterpressInvitationSample: FreeLetterpressInvitationSample,
  PaidLetterpressInvitationSample: PaidLetterpressInvitationSample,
  RibbonSample: RibbonSample
};